module.exports = __webpack_public_path__ + "img/Crooked Channel.0e03c200.png";